import { render, staticRenderFns } from "./DigitalSign.vue?vue&type=template&id=765c4f8d&scoped=true&"
import script from "./DigitalSign.vue?vue&type=script&lang=js&"
export * from "./DigitalSign.vue?vue&type=script&lang=js&"
import style0 from "./DigitalSign.vue?vue&type=style&index=0&id=765c4f8d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765c4f8d",
  null
  
)

export default component.exports